import styled, { css } from 'styled-components';

import {
  skinsGroupage,
  storeColor,
  aggregatedColor,
} from 'modules/journey/card/styled/groupageBackground';

const stylesBasedOnStopProperties = () => css`
  background-color: ${({ skin, isAggregated, store }) => {
    if (store) {
      return storeColor;
    }
    if (isAggregated) {
      return aggregatedColor;
    }
    return skinsGroupage[skin] ? skinsGroupage[skin] : 'var(--grey200)';
  }};

  color: ${({ isAggregated, store }) =>
    isAggregated || store ? 'var(--white)' : 'var(--blackBat)'};
`;

const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 0px 8px;
  height: 26px;
  border-radius: 5px 5px 0px 0px;

  ${stylesBasedOnStopProperties}

  .header-row__stop-id {
    margin-right: 1.6rem;
  }

  .header-row__entity-id {
    margin-left: auto;
    font-weight: normal;
  }

  .header-row__orders-parent {
    margin-left: auto;
    display: flex;
    align-items: center;
    & > * {
      margin-right: 0.4rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .header-row__locator-parent {
    margin-left: auto;
  }
`;

export default StyledHeaderRow;
